const styles = `:host {
  --goto-icon-color: design-token(text-06);
  --goto-icon-size: 20px;
  cursor: pointer;
  position: relative;
  display: inline-flex;
  align-items: center;
  outline: 0;
}
:host .control {
  border-width: 1px;
  border-style: solid;
  height: 16px;
  width: 16px;
  position: relative;
  box-sizing: border-box;
  outline: none;
  border-radius: 4px;
  border-color: var(--goto-ui-03);
  background-color: var(--goto-ui-01);
  flex-shrink: 0;
  margin-top: 1px;
  align-items: center;
}
:host .control:hover {
  background-color: var(--goto-hover-01);
  border-color: var(--goto-ui-03);
}
:host .control:active {
  background-color: var(--goto-pressed-01);
  border-color: var(--goto-ui-03);
  box-shadow: none;
}
:host .label {
  color: var(--goto-text-01);
  cursor: pointer;
  font: var(--goto-body-small);
  margin-left: 8px;
}
:host [name=checked-indicator],
:host [name=indeterminate-indicator] {
  display: none;
  pointer-events: none;
  position: absolute;
  top: -3px;
  left: -3px;
}

:host(:focus-visible) .control {
  border-color: var(--goto-focus);
  box-shadow: var(--goto-highlight);
}

:host([size=large]) {
  --goto-icon-size: 24px;
}
:host([size=large]) .control {
  height: 20px;
  width: 20px;
}
:host([size=large]) .label {
  font: var(--goto-body-medium);
}

:host(.checked) .control,
:host(.indeterminate) .control {
  background-color: var(--goto-information-01);
  border-color: var(--goto-information-01);
  color: var(--goto-text-06);
}
:host(.checked) .control:hover,
:host(.indeterminate) .control:hover {
  background-color: var(--goto-hover-primary);
  border-color: var(--goto-hover-primary);
}
:host(.checked) .control:active,
:host(.indeterminate) .control:active {
  background-color: var(--goto-pressed-primary);
  border-color: var(--goto-pressed-primary);
}

:host(.checked) [name=checked-indicator] {
  display: block;
}

:host(.indeterminate) [name=indeterminate-indicator] {
  display: block;
}
:host(.indeterminate) [name=checked-indicator] {
  display: none;
}

:host([disabled]) {
  cursor: default;
}
:host([disabled]) .label {
  cursor: default;
  color: var(--goto-text-03);
}
:host([disabled]) .control {
  background-color: var(--goto-disabled-04);
  border-color: var(--goto-toolbar-disabled-icon-color);
  color: var(--goto-text-06);
}

:host([disabled].checked) .control {
  background-color: var(--goto-toolbar-disabled-icon-color);
  border-color: var(--goto-toolbar-disabled-icon-color);
  color: var(--goto-text-06);
}`; export default styles;